import { LogOut, Settings as SettingsIcon } from 'lucide-react';
import { Link } from 'react-router';

export function MasterHeader() {
  return (
    <header className="border-border bg-card border-b">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 sm:px-6">
        <Link to="/" className="font-display text-xl font-semibold tracking-tight">
          DeutschApp
        </Link>
        <nav className="flex items-center gap-1 sm:gap-3">
          <Link
            to="/settings"
            className="text-muted-foreground hover:bg-muted hover:text-foreground inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors"
          >
            <SettingsIcon className="size-4" />
            <span className="hidden sm:inline">Settings</span>
          </Link>
          <a
            href="/cdn-cgi/access/logout"
            className="text-muted-foreground hover:bg-muted hover:text-foreground inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors"
          >
            <LogOut className="size-4" />
            <span className="hidden sm:inline">Sign out</span>
          </a>
        </nav>
      </div>
    </header>
  );
}
